import { MissingTranslationError } from 'react-intl'
import { LOG_LEVEL_WARN, LOG_TYPE_INTL } from 'typings'
import { processStack } from '../../components/utils'

declare global {
  interface Window {
    __intlProcessedLabels?: Set<string>
  }
}

function getProcessedLabels(): Set<string> {
  if (!window.__intlProcessedLabels) {
    window.__intlProcessedLabels = new Set<string>()
  }
  return window.__intlProcessedLabels
}

function saveProcessedLabels(labels: Set<string>): void {
  window.__intlProcessedLabels = labels
}

export class IntlErrorLogger {
  private logger: any = null

  constructor(logger: any) {
    this.logger = logger
  }

  async logError(error: MissingTranslationError, language: string) {
    if (!this.logger) return

    const label = error.descriptor?.id ?? 'unknown'
    const processedLabels = getProcessedLabels()

    if (processedLabels.has(label)) return

    processedLabels.add(label)
    saveProcessedLabels(processedLabels)

    try {
      const stack = (await processStack(error)) ?? error.stack

      this.logger({
        type: LOG_TYPE_INTL,
        level: LOG_LEVEL_WARN,
        message: error.code,
        metadata: {
          label,
          language,
          cause: error.message,
          stack,
        },
      })
    } catch (error) {}
  }
}
